import request from '@/axios';

export const getDataPage = (current, size, params) => {
  return request({
    url: '/emp-business/blade-view/view/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
    filterEmptyParams: true
  });
};

export const getPageList = (params) => {
  return request({
    url: '/emp-business/blade-view/view/list',
    method: 'get',
    params,
  });
};

export const savePage = row => {
  return request({
    url: '/emp-business/blade-view/view/save',
    method: 'post',
    data: row,
  });
};

export const updatePage = row => {
  return request({
    url: '/emp-business/blade-view/view/update',
    method: 'post',
    data: row,
  });
};

export const removePage = ids => {
  return request({
    url: '/emp-business/blade-view/view/remove',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const getDataPageDetail = (params) => {
  return request({
    url: '/emp-business/blade-view/view/detail',
    method: 'get',
    params,
  });
};
